/* eslint-disable react/prop-types */
import { _PaymentStatus } from "../styles";
import { useV2OrderPayer } from "../../../data/orderPayer";
import { Spinner } from '@applyboard/crystal-ui';
import React from 'react';
var PaymentStatus = function PaymentStatus(_ref) {
  var permissions = _ref.permissions,
    info = _ref.info,
    formattedDate = _ref.formattedDate;
  var orderIdIndexInSplitUrl = 2;
  var orderId = info.payment_receipt_url.split('/')[orderIdIndexInSplitUrl];
  var hasAccessToViewOrders = !!(permissions !== null && permissions !== void 0 && permissions.p_view_orders);
  var _useV2OrderPayer = useV2OrderPayer(orderId, {
      enabled: hasAccessToViewOrders
    }),
    isLoadingV2OrderPayer = _useV2OrderPayer.isLoadingV2OrderPayer,
    v2OrderPayerError = _useV2OrderPayer.v2OrderPayerError;
  var isLoading = hasAccessToViewOrders && isLoadingV2OrderPayer;
  var isError = hasAccessToViewOrders && !!v2OrderPayerError;
  var showReceiptLink = !isError && !!hasAccessToViewOrders;
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, null));
  }
  return /*#__PURE__*/React.createElement(_PaymentStatus, null, showReceiptLink ? /*#__PURE__*/React.createElement("a", {
    href: info.payment_receipt_url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Receipt") : null, showReceiptLink ? ' | ' : null, " ", /*#__PURE__*/React.createElement("span", null, formattedDate));
};
export default PaymentStatus;